// ManualDestinationsCard — Settings → Integrations mirror of the inline
// editor used on /publisher. Lets users curate the list of manual
// (copy-and-paste) publishing destinations for the active workspace.

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ManualDestinationsEditor } from "@/components/publisher/ManualDestinationsEditor";
import { useAuth } from "@/hooks/useAuth";
import type { Workspace } from "@/hooks/useWorkspace";

type Props = { workspace: Workspace };

export const ManualDestinationsCard = ({ workspace }: Props) => {
  const { user } = useAuth();
  if (!user) return null;
  return (
    <Card className="shadow-soft">
      <CardHeader>
        <CardTitle>Manual publishing destinations</CardTitle>
      </CardHeader>
      <CardContent>
        <ManualDestinationsEditor workspaceId={workspace.id} userId={user.id} />
      </CardContent>
    </Card>
  );
};
